import { locationService } from '../services/locationService';
import { referenceDataSyncService } from '../../services/referenceDataSyncService';
import { removeDuplicate } from '../../utils/removeDuplicate';
import { Location } from '../../types/locationType';

export class LocationRepository {
  async loadLocations(
    isOnline: boolean,
    onUpdate?: (locations: Location[]) => void,
    onLoadingComplete?: () => void
  ): Promise<Location[]> {
    const offline = await referenceDataSyncService.getLocations();
    const initialData = (offline as unknown as Location[]) || [];

    if (initialData?.length > 0 && onUpdate) {
      onUpdate(initialData);
    }

    const shouldFetchOnline = isOnline;

    if (shouldFetchOnline) {
      locationService
        .getLocations()
        .then((res: any) => {
          if (res?.data && res?.data?.length > 0) {
            if (onUpdate) {
              onUpdate(res?.data);
            }
          }
        })
        .catch((error) => {
          console.warn('Failed to load locations online in background', error);
        })
        .finally(() => {
          if (onLoadingComplete) {
            onLoadingComplete();
          }
        });
    } else {
      if (onLoadingComplete) {
        onLoadingComplete();
      }
    }

    return initialData;
  }

  getUniqueDepartments(locations: Location[]): { label: string; value: string; id: number }[] {
    const departmentOptionArr = locations?.map((location) => ({
      label: location?.district,
      value: location?.district,
      id: location?.id,
    }));
    return removeDuplicate(departmentOptionArr, 'value');
  }

  filterByDepartment(locations: Location[], department: string): Location[] {
    if (!department) return [];
    return locations.filter((loc) => loc?.district === department);
  }
}

export const locationRepository = new LocationRepository();
